import STRINGS from 'utils/strings'
import { getStudyDurationForTimeline, getStudyDurationFromStudy } from 'utils/studyDurationForTimeline'
import { VISIT_DEPLOYMENT_KEYS } from '../../../../VisitSchedulesPage/utils/visitsScheduleUtils'

export const getCreateVisitTemplateErrors = visitTemplate => {
  const errors = {}
  const { name } = visitTemplate
  if (!name || name === '') errors.name = STRINGS.visitNameErr
  return errors
}
export const getCreateTemplateVisitErrors = (templateVisit, study = null) => {
  const errors = {}
  const { name, visit_metadata = {}, metadata = {}, visit_day, day, visit_window, window } = templateVisit

  // Get values with fallbacks
  const dayValue = visit_day ?? day
  const windowValue = visit_window ?? window
  const displayName = visit_metadata?.display_name || metadata?.display_name
  const deployment_option = visit_metadata?.deployment_option ?? metadata?.deployment_option

  // Validate completes cycle
  if (visit_metadata.deployment_option === VISIT_DEPLOYMENT_KEYS.completesCycle && !visit_metadata.relative_cycle_id) {
    errors.complete_cycle = STRINGS.visitScheduleCompletesCycleError
  }

  // Validate completes visit
  if (visit_metadata.deployment_option === VISIT_DEPLOYMENT_KEYS.completesVisit && !visit_metadata.relative_visit_id) {
    errors.complete_visit = STRINGS.visitScheduleCompletesVisitError
  }

  // Validate name (check for empty string and whitespace-only strings)
  if (!name || name.trim().length === 0) {
    errors.name = STRINGS.visitNameErr
  }

  // Validate display name
  if (!displayName) {
    errors.display_name = STRINGS.appDisplayNameErr
  }

  // Validate day
  if (dayValue == null || dayValue === '') {
    errors.visit_day = STRINGS.visitDayErr
  } else if (dayValue < 0) {
    errors.visit_day = STRINGS.visitDayNegErr
  } else if (deployment_option === 'joins') {
    // Prefer session (studyDurationForTimeline = study duration in days), then derive from study
    const studyDurationPayload = getStudyDurationForTimeline() || (study ? getStudyDurationFromStudy(study) : null)
    const studyDurationInDays = studyDurationPayload?.study_duration
    if (typeof studyDurationInDays === 'number' && Number.isFinite(studyDurationInDays) && dayValue >= studyDurationInDays) {
      errors.visit_day = STRINGS.visitDayExceedsStudyDuration.replace('{value}', String(studyDurationInDays))
    }
  }

  // Validate window
  if (windowValue == null || windowValue === '') {
    errors.visit_window = STRINGS.visitWindowErr
  } else if (windowValue < 0) {
    errors.visit_window = STRINGS.visitWindowNegErr
  }

  return errors
}
